export default __webpack_public_path__ + "static/media/rose.518720f9.jpg";